<style>
  #merchantHeader-inner {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: start;
    vertical-align: middle;
  }

  #merchantHeader-inner .section {
    flex: auto;
  }

  .statusBar {
    padding: 4px 10px;
    font-size: 0.9em;
    text-align: center;
  }
  .statusDisabled {
    background-color: #aaaaaa;
    color: #000000;
  }
  .statusTest {
    background-color: #ffcc00;
    color: #000000;
  }
  .statusLive {
    background-color: #aa0000;
    color: #ffffff;
  }
</style>

@if (currentMerchant != undefined) {

  <div style="display:flex; width:100%; margin:15px 0px;">

    <div style="flex:1; padding-left: var(--page-left-padding);">
      <h1>{{ currentMerchant.DBA }}</h1>
    </div>
    <div style="display: flex; padding-right:24px; font-size:.9em; color:var(--green-800)">
      <div style="display: flex; flex-direction: row; gap: 20px;">
        <div style="font-weight: 300">your processor{{ currentMerchant.processors.length > 1 ? 's' : '' }}:</div>

        @for (p of currentMerchant.processors; track p) {
          @let details = getProcessorDetails(p.processor);
          <div style="font-weight: 400">
            <div>
              <div>
              {{ p.processor }} 
              @if (details?.type) {
                ({{details.type}})
              }
              </div>
              <div style="font-size:.8em;">#{{ p.mid }}</div>
              @if (details?.phone) {
                <div>{{UIHelpers.formatPhone(details.phone, "1234567890")  }}</div>
              }
              @if (details?.email || details?.website) {
                <div class="help-link">
                @if (details?.email) {
                  <a href="http://mailto:{{ details.email }}" target="_blank">email</a> |
                }
                @if (details?.website) {
                  <a href="{{ details.website }}" target="_blank">website</a>
                }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

  </div>
}
